import { MainLayout } from 'components/layouts/MainLayout';
import { FC } from 'types/global';
import { HeaderProjectList } from 'components/grid/headers/LoadHeaderMangerProject';

export const LoadLayoutManager: FC<object> = ({ children }) => {
  return <MainLayout Header={HeaderProjectList}>{children}</MainLayout>;
};
